var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 44,
    viewBox: "0 0 54 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6668 32.6667H24.3335C22.8607 32.6667 21.6668 31.4728 21.6668 30V3.33333C21.6668 1.86058 22.8607 0.666668 24.3335 0.666668H29.6668C31.1396 0.666668 32.3335 1.86058 32.3335 3.33333V30C32.3335 31.4728 31.1396 32.6667 29.6668 32.6667ZM5.66683 24.6667V30C5.66683 31.4728 6.86074 32.6667 8.3335 32.6667H13.6668C15.1396 32.6667 16.3335 31.4728 16.3335 30V24.6667C16.3335 23.1939 15.1396 22 13.6668 22H8.3335C6.86074 22 5.66683 23.1939 5.66683 24.6667ZM40.3335 32.6667H45.6668C47.1396 32.6667 48.3335 31.4728 48.3335 30V14C48.3335 12.5272 47.1396 11.3333 45.6668 11.3333H40.3335C38.8607 11.3333 37.6668 12.5272 37.6668 14V30C37.6668 31.4728 38.8607 32.6667 40.3335 32.6667ZM1.66683 38H52.3335C53.0699 38 53.6668 38.597 53.6668 39.3333V42C53.6668 42.7364 53.0699 43.3333 52.3335 43.3333H1.66683C0.93045 43.3333 0.333496 42.7364 0.333496 42V39.3333C0.333496 38.597 0.93045 38 1.66683 38Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.b6a5e81d035ab8efef0185aacbb38e31.svg";
export { ForwardRef as ReactComponent };